import { useQuery } from '@tanstack/react-query';
import type { SharedCustomField } from '@/types/serializers';

export default function useFetchOrganizationCandidateProfilesCustomFields() {
  return useQuery<SharedCustomField[] | null>({
    queryKey: ['organization_candidate_profiles_custom_fields'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_profiles/custom_fields');
      if (!response.ok) {
        if (response.status === 404) {
          return null;
        }
        throw new Error('Failed to fetch custom fields');
      }
      const data = await response.json();
      return data.records as SharedCustomField[];
    },
  });
}
